import type { ReactNode } from "react";
import type { ViewspecState } from "../viewspecs/types.ts";

interface SplitViewProps {
  mode: ViewspecState["splitMode"];
  leftPane: ReactNode;
  rightPane: ReactNode;
}

export function SplitView({ mode, leftPane, rightPane }: SplitViewProps) {
  if (mode === "none") {
    return <>{leftPane}</>;
  }

  return (
    <div
      className={`split-view ${mode}`}
      style={{ height: "100%" }}
    >
      <div className="split-pane" style={{ overflow: "auto" }}>
        {leftPane}
      </div>
      <div className="split-divider" />
      <div className="split-pane" style={{ overflow: "auto" }}>
        {rightPane}
      </div>
    </div>
  );
}
